import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const SuperAdminRoute = ({ children }) => {
  const { user, loading, isSuperAdmin } = useAuth();

  if (loading) {
    return null;
  }

  if (!user || !isSuperAdmin) {
    return <Navigate to="/auth/404" replace />;
  }

  return children;
};

export default SuperAdminRoute;
